import './plans.css';
import ToolCards from '../../../../components/toolCards/toolCards';

import { useNavigate, useSearchParams } from 'react-router-dom';

// Icons

import IndividualPlans from '../../../../assets/icons/individualPlans/individualPlans';
import EnterprisePlan from '../../../../assets/icons/enterprisePlan/enterprisePlan';

import ToolFlipCards from '../../../../components/toolFlipCards/toolFlipCards';

export default function Plans({isMobile}) { 

    const navigate = useNavigate();

    const startButton = () => {
        navigate('/sign_up'); 
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
            });
    };

    return(
        <div className="plans">
            <div className="plans-container">
                <div className="plans-title">
                    <h1>Plans Catered to your business</h1>
                    <p>Personal plan for individuals and small businesses that need essential expense tracking. Business plan for growing teams that require advanced controls and scalable reporting.</p>
                </div>
                {isMobile ?

                <div className="mobile-plans-content-cards">
                    <ToolFlipCards flipQuantity={false} cardSize={true}
                                    iconOne={<IndividualPlans/>} iconTwo={<EnterprisePlan/>}
                                    titleOne='Individual Plans' titleTwo='Enterprise Plan'
                                    barBool={true} barWidth={'80%'} barCenter={'auto'} barColor={'var(--text-color)'}
                                    subTitleOne={'Simple, affordable expense tracking for individuals & small teams'} subTitleTwo={'Scalable finance control for growing organizations'}
                                    textContentTopOne={'Essential features to capture, categorize, and report expenses with minimal setup.'} textContentTopTwo={'Advanced admin controls, permissions, and integrations to manage multi-department spending at scale.'}
                                    bulletPointsOne={[
                                        "Up to 3 users",
                                        "Unlimited expense entries",
                                        "Basic reporting (CSV export)",
                                        "Receipt Capture",
                                        "Email Support"
                                    ]} 
                                    bulletPointsTwo={[
                                        "Unlimited users & profiles",
                                        "Role-based permissions & approval",
                                        "Advanced reporting & scheduled exports",
                                        "Single sign-on (SSO) & audit logs",
                                        "Priority support & onboarding",
                                        "Dedicated account manager",
                                        "Custom integrations"
                                    ]}
                                    textContentBottomOne={'Best for freelancers, solo entrepreneurs, and micro-businesses.'} 
                                    textContentBottomTwo={'Perfect for mid-size to large companies, finance teams, and organizations requiring compliance and scale.'}
                                    isMobile={isMobile}
                                    button='Start!'
                                    onClick={startButton}
                                    />
                </div>

                :
                    
                <div className="plans-content-cards">
                    <div>
                        <ToolCards 
                        size={false} 
                        icon={<IndividualPlans/>}
                        title={"Individual Plan"} 
                        barBool={true}
                        barWidth={'20rem'}
                        barCenter={'auto'}
                        barColor={'var(--text-color)'}  
                        subTitle={"Simple, affordable expense tracking for individuals & small teams"}
                        textContentTop={"Essential features to capture, categorize, and report expenses with minimal setup."}
                        bulletPoints={[
                            "Up to 3 users",
                            "Unlimited expense entries",
                            "Basic reporting (CSV export)",
                            "Receipt Capture",
                            "Email Support"]} 
                            
                        textContentBottom={"Best for freelancers, solo entrepreneurs, and micro-businesses."}
                        buttonBool={true}
                        button="Start!"
                        onClick={startButton}
                        />
                    </div>
                    <div>
                        <ToolCards 
                        size={false} 
                        icon={<EnterprisePlan/>}
                        title={"Enterprise Plan"} 
                        barBool={true}
                        barWidth={'20rem'}
                        barCenter={'auto'}
                        barColor={'var(--text-color)'} 
                        subTitle={"Scalable finance control for growing organizations"}
                        textContentTop={"Advanced admin controls, permissions, and integrations to manage multi-department spending at scale."}
                        bulletPoints={[
                            "Unlimited users & profiles",
                            "Role-based permissions & approval",
                            "Advanced reporting & scheduled exports",
                            "Single sign-on (SSO) & audit logs",
                            "Priority support & onboarding",
                            "Dedicated account manager",
                            "Custom integrations"]}
                        textContentBottom={"Perfect for mid-size to large companies, finance teams, and organizations requiring compliance and scale."}
                        buttonBool={true}
                        button="Start!"
                        onClick={startButton}
                        />
                    </div>
                </div>
                
                }
            </div>
        </div>
    )
};